export { W3CMutableBaggagePropagator } from './w3c-mutable-baggage-propagator';
export { MutableBaggageImpl } from './mutable-baggage-impl';
